// Purpose: check if user is logged in or not
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {Div, Button, Label} from './styles/CheckUserIsAuthed-style';
import Cookies from "universal-cookie";

const cookies = new Cookies();

const CheckUserIsAuthed = () => {
    const isLoggedIn = document.cookie.includes('token');

    const navigate = useNavigate();

    const NavigateToLoginPage = () => navigate('/Login');
    const logout = () => {
        cookies.remove("token", { path: '/' });
        navigate(`/Login`);
    }

    return (
        isLoggedIn ? (
            <Div>
                <Label>Username</Label>
                <Button onClick={logout}>Logout</Button>
            </Div>
            ) : (
            <Div>
                <Label>Not logged in</Label>  
                <Button onClick={NavigateToLoginPage}>Login</Button>
            </Div>
        )
        );
}

export default CheckUserIsAuthed;
